// Deterministic carrier -> tracking-page URL (WQ-260819-01 A). Returns null for anything
// unrecognized, and the UI then renders plain text. Never guess the carrier from the number's
// format - a wrong guess sends the user to the wrong carrier's site with a real tracking number
// and the page will happily say "not found".
export const CARRIERS = [
  { value: 'ups', label: 'UPS' },
  { value: 'fedex', label: 'FedEx' },
  { value: 'usps', label: 'USPS' },
  { value: 'other', label: 'Other' },
];

const normalize = (carrier) => (carrier || '').trim().toLowerCase();

export function carrierLabel(carrier) {
  const hit = CARRIERS.find((c) => c.value === normalize(carrier));
  return hit ? hit.label : carrier || '';
}

export function trackingUrl(carrier, trackingNumber) {
  const num = (trackingNumber || '').trim();
  if (!num) return null;
  switch (normalize(carrier)) {
    case 'ups':
      return `https://www.ups.com/track?tracknum=${encodeURIComponent(num)}`;
    case 'fedex':
      return `https://www.fedex.com/fedextrack/?trknbr=${encodeURIComponent(num)}`;
    case 'usps':
      return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${encodeURIComponent(num)}`;
    default:
      return null;
  }
}
